import { ProfileAvatar } from "../../../profile/ProfileAvatar";
import { Stack, Typography } from "@mui/material";

type Props = {
  fullname: string;
  avatar_url: string;
  email: string;
  isCurrentUser: boolean;
};

export const NameBlock = ({
  fullname,
  avatar_url,
  email,
  isCurrentUser,
}: Props) => {
  return (
    <Stack flexDirection="row" gap="10px" alignItems="center" width="100%">
      <ProfileAvatar avatar_url={avatar_url} height="24px" width="24px" />
      <Stack paddingY="4px">
        <Typography
          sx={{
            fontSize: 14,
            lineHeight: "22px",
            fontWeight: "400",
            color: "#232323",
          }}
        >
          {fullname}{" "}
          {isCurrentUser && <span style={{ color: "#9B9B9B" }}>(you)</span>}
        </Typography>
        <Typography
          sx={{
            fontSize: 12,
            fontWeight: "400",
            color: "#797979",
            wordBreak: "break-all",
            whiteSpace: "normal",
          }}
        >
          {email}
        </Typography>
      </Stack>
    </Stack>
  );
};
